import { BehaviorSubject } from "rxjs";
import { DomainId } from "../../../../config";
import { Software } from "../../../../models";
import { AutocompleteDefinition } from "../autocomplete-definition";

export class AutocompleteSoftwareDefinition implements AutocompleteDefinition<Software> {
  identifier = "id";
  initialValues$ = new BehaviorSubject<Array<Software>>([]);
  maximumNumberOfSelectedEntities = 1;

  dataMapper = (data: any) => (data || {}).softwares?.map(s => ({
    id: s.id,
    name: s.name,
    urlAlias: s.softwareDomain?.alias,
    path: s.softwareDomain?.path
  }))

  queryBuilder = (domainId: DomainId, typed: string, limit: string) => `{
      softwares(
        isPublishedInDomain: ${domainId}
        limit: ${limit}
        partialName: "${typed}"
        sorts: [{ order: ASC, property: nameLength }]
      ) {
        id
        name
        softwareDomain(domain: ${domainId}) {
          path
          alias
        }
      }
    }
  `

  display(software: Software): string {
    return `${software.name} (urlAlias: ${software.urlAlias})`;
  }

  setMaximumNumberOfSelectedEntities(maxSize: number): AutocompleteDefinition<Software> {
    this.maximumNumberOfSelectedEntities = maxSize;
    return this;
  }
}
